import React from 'react';

import Copyright from 'lego-on-react/src/components/copyright/copyright.react';

import { useConfig } from 'client/common/hooks';

import 'lego-on-react/src/components/copyright/copyright.css';

export default function () {
    const { mordaHost, tld } = useConfig();

    return (
        <Copyright start={2004} url={mordaHost} content={['com', 'cn', 'com.tr'].includes(tld) ? 'YANDEX' : 'ЯНДЕКС'}>
            {['com', 'cn', 'com.tr'].includes(tld) ? 'YANDEX' : 'ЯНДЕКС'}
        </Copyright>
    );
}
